import { Theme } from '../types';

// Neutrals carry a barely-there warm tint (hue 70, chroma ≤ 0.006) so they never read as flat gray,
// and never as beige. One accent — Swift orange — used sparingly for state and emphasis.
const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1200px',
};

export const lightTheme: Theme = {
  colors: {
    background: 'oklch(98.9% 0.002 70)',
    backgroundAlt: 'oklch(96.4% 0.003 70)',
    cardBackground: 'oklch(99.7% 0.001 70)',
    text: 'oklch(21% 0.006 60)',
    textSecondary: 'oklch(45% 0.008 60)',
    textTertiary: 'oklch(58% 0.007 60)',
    primary: 'oklch(64% 0.19 36)',
    primaryHover: 'oklch(59% 0.19 36)',
    primaryText: 'oklch(54% 0.17 36)',
    onPrimary: 'oklch(99% 0.002 70)',
    border: 'oklch(21% 0.006 60 / 0.09)',
    borderStrong: 'oklch(21% 0.006 60 / 0.16)',
    overlay: 'oklch(98.9% 0.002 70 / 0.82)',
    success: 'oklch(58% 0.14 150)',
    warning: 'oklch(72% 0.15 75)',
    error: 'oklch(56% 0.19 27)',
  },
  shadows: {
    small: '0 1px 2px oklch(21% 0.006 60 / 0.06)',
    medium: '0 1px 2px oklch(21% 0.006 60 / 0.05), 0 4px 12px oklch(21% 0.006 60 / 0.06)',
    large: '0 1px 2px oklch(21% 0.006 60 / 0.06), 0 8px 24px oklch(21% 0.006 60 / 0.08), 0 24px 48px -12px oklch(21% 0.006 60 / 0.12)',
  },
  breakpoints,
};

export const darkTheme: Theme = {
  colors: {
    background: 'oklch(16.5% 0.004 60)',
    backgroundAlt: 'oklch(19.5% 0.005 60)',
    cardBackground: 'oklch(21% 0.005 60)',
    text: 'oklch(95.5% 0.003 70)',
    textSecondary: 'oklch(73% 0.006 70)',
    textTertiary: 'oklch(58% 0.006 70)',
    primary: 'oklch(69% 0.17 40)',
    primaryHover: 'oklch(74% 0.16 40)',
    primaryText: 'oklch(74% 0.15 42)',
    onPrimary: 'oklch(16.5% 0.004 60)',
    border: 'oklch(95.5% 0.003 70 / 0.09)',
    borderStrong: 'oklch(95.5% 0.003 70 / 0.16)',
    overlay: 'oklch(16.5% 0.004 60 / 0.8)',
    success: 'oklch(72% 0.15 150)',
    warning: 'oklch(82% 0.14 85)',
    error: 'oklch(68% 0.18 27)',
  },
  shadows: {
    small: '0 1px 2px oklch(0% 0 0 / 0.3)',
    medium: '0 1px 2px oklch(0% 0 0 / 0.3), 0 4px 12px oklch(0% 0 0 / 0.25)',
    large: '0 1px 2px oklch(0% 0 0 / 0.35), 0 8px 24px oklch(0% 0 0 / 0.3), 0 24px 48px -12px oklch(0% 0 0 / 0.4)',
  },
  breakpoints,
};

// Add theme name property for conditional styling
export const lightThemeWithName = {
  ...lightTheme,
  name: 'light' as const
};

export const darkThemeWithName = {
  ...darkTheme,
  name: 'dark' as const
};
